import React from 'react';
import styled from 'styled-components/macro';
import LogoRegis from '../../assets/img/logoRegisNegro.png';
import { responsive } from '../../resources/constantes.json';
/**
 *  Lista de checkbox que permite elegir entre varias opciones. Se utiliza en la pantalla
 * de estadísitcas para elegir entre distintos tipos de estadísticas.
 */

const FooterLayout = props => {

  return (
    <FooterContainer estadisticas={props.estadisticas} >
      <SLogoRegistraduria>
        <img src={LogoRegis} alt={"Logo registraduria"} />
      </SLogoRegistraduria>
      <div>
      <TextFooter>
        *Partido con empates. **Curul pendiente de asignación oficial.
        </TextFooter>
        <TextFooter>
        Los porcentajes se calculan con truncamiento a dos decimales. Entiéndase
        por agrupación política una lista independiente, un proceso y práctica
        organizativa o un partido y movimiento político. Resolución 1706 de 2019
        del CNE: los boletines expedidos por la Registraduría Nacional del
        Estado Civil, durante el denominado preconteo, no son de carácter
        vinculante y tienen mero carácter informativo, por lo que no pueden
        considerarse como documentos electorales que definan una elección.
      </TextFooter>
      <TextFooter>
      Esta simulación de aplicación de la fórmula electoral para la distribución de curules del Senado de la República y Cámara de Representantes se realiza en concordancia con lo dispuesto en el artículo 263 de la Constitución Política. No obstante, este ejercicio no refleja la votación obtenida por el Partido Político Comunes, dado que las reglas especiales contenidas en los artículos transitorios 2 y 3 del Acto Legislativo 03 de 2017 "Por medio del cual se regula parcialmente el componente de reincorporación política del Acuerdo Final para la Terminación del Conflicto y la Construcción de una Paz Estable y Duradera", les reconoce el derecho a ocupar 5 curules adicionales en Senado y 5 en Cámara, independientemente de la votación obtenida.
      </TextFooter>
      </div>
    </FooterContainer>
  );
};

export default FooterLayout;

const SLogoRegistraduria = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  & img {
    height: 80px;
    vertical-align: middle;
    margin-right: 20px;
  }
  @media (max-width: 1024px) {
    padding: 0 15px;
  }
`;
const FooterContainer  = styled(({ estadisticas, ...rest }) => (
  <footer {...rest} />
))`
 width: 100%;
 display: flex;
 flex-direction: row;
 align-items: center;
 background: ${({ estadisticas }) => estadisticas ? "white" : "transparent"};
 @media (max-width: ${responsive.tablet}px) {
  padding-top: 10px;
  width: 100%;
  flex-direction: column;
}
`;

const TextFooter  = styled.p`
 font-size: 10px;
 line-height: 15px;
`;